// const API_URL = 'https://jph.purvsoft.com';
// export { API_URL };
const SUBDOMAIN = 'jph';
const API_URL = `https://${SUBDOMAIN}.purvsoft.com`;
export { API_URL };
const image_url = `https://${SUBDOMAIN}.purvsoft.com/`;
export { image_url };
const contactConfig = {
  email: "jphomeservice1@gmail.com",
  phone: "+918780438907",
  phone1: "+919327365056",
  address: "B-319 Swaminarayan Avenue, AEC Office, Naranpura, Ahmedabad",
  Time:'Monday to Saturday: 10:00 AM - 7:00 PM',
  day:'Monday to Saturday',
  time:'9 AM - 6 PM',
  whatsapp: "+918780438907"
};

export default contactConfig;
